import {
  MOBILE_RECOVERY_PATH,
  MOBILE_RECOVERY_URL,
  parseMobileRecoveryLink,
} from "@/shared/mobile-password-recovery";

let tokenHash: string | null = null;
// Imported by instrumentation-client before Sentry or application providers start.
if (typeof window !== "undefined" && window.location.pathname === MOBILE_RECOVERY_PATH) {
  tokenHash =
    parseMobileRecoveryLink(MOBILE_RECOVERY_URL + window.location.search + window.location.hash)
      ?.tokenHash ?? null;
  try {
    window.history.replaceState(window.history.state, "", MOBILE_RECOVERY_PATH);
  } catch {
    tokenHash = null;
  }
}

export function getBrowserRecoveryToken() {
  return tokenHash;
}
export function clearBrowserRecoveryToken() {
  tokenHash = null;
}
